import Slider from "rc-slider";
import React, { useCallback, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { SkeletonTheme } from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";
import { useDebounce } from "use-debounce";
import ItemCard from "../../components/ItemCard";
import { PlayerItemType } from "../../types/items";
import { roundFloat } from "../../utils/round-float";
import networkInstance from "../../redux/api/Network";

type Props = {};

const Items = (props: Props) => {
  const [items, setItems] = useState<PlayerItemType[] | undefined>(undefined);
  const [level, setLevel] = useState<number>(1);
  const [damage, setDamage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  const [changedDamageBounced] = useDebounce(damage, 400);

  const handleGetData = useCallback(async () => {
    setLoading(true);
    const response = await networkInstance.CallApi({
      url: "/item",
      method: "get",
    });
    setItems(response.data);
    setLoading(false);
  }, []);

  useEffect(() => {
    setLevel(changedDamageBounced);
    handleGetData();
  }, [changedDamageBounced, handleGetData]);

  return (
    <SkeletonTheme
      enableAnimation={!isMobile}
      baseColor="#3e382b"
      highlightColor="#474132"
    >
      <div>
        <div className="mt-4 text-secondary text-center">
          <Trans
            i18nKey="learn:items.description"
            components={{
              marketplace: <Link to="/marketplace" />,
              treasure: <Link to="/treasure/select" />,
            }}
          />
        </div>
        <div style={{ maxWidth: 600 }} className="w-100 mb-5 mt-4 mx-auto">
          <Slider
            step={1}
            value={damage}
            onChange={(val) => setDamage(val as number)}
            max={8}
            min={1}
            marks={{ 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8 }}
          />
        </div>
        <div className="row align-items-center justify-content-center mt-2">
          {loading &&
            new Array(26)
              .fill((i) => i + 1)
              ?.map((item) => (
                <div className="col-12 mt-2 text-white  col-xl-3 col-lg-4 col-sm-6 ">
                  <ItemCard loading={loading} />
                </div>
              ))}
          {!loading &&
            items?.map((item, index) => (
              <div
                className="col-12 mt-2 text-white col-xl-3 col-lg-4 col-sm-6"
                key={index}
              >
                <ItemCard
                  data={{
                    ...item,
                    item: item as any,
                    image: `https://core.chainoflegends.com/assets/items/item${item.id}-level${level}.png`,
                    level: level,
                    bonusValue: +(item?.bonusStat === 6
                      ? item.bonusValue + (level - 1)
                      : roundFloat(
                          Math.pow(1.5, level - 1) * item.bonusValue,
                          0
                        )),
                  }}
                  loading={false}
                  noAction
                />
              </div>
            ))}
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default Items;
